<template>
    <section class="section is-relative">
        <b-loading v-model="isLoading" :is-full-page="false"/>
        <div class="tile is-ancestor" v-for="tickets in chunkedTickets">
            <router-link class="tile is-parent" v-for="ticket in tickets" :key="ticket.id"
                         :to="{name: 'tickets.show', params: {id: ticket.id}}">
                <article class="tile is-child box is-flex is-flex-direction-column">
                    <p class="title">{{ ticket.title }}</p>
                    <div class="content">
                        <p>{{ ticket.description }}</p>
                    </div>
                    <div class="pos is-absolute is-bottom" style="margin-top: auto">
                        <b-icon icon="ticket-outline"/>
                        {{ ticket.questionsAmount }}
                        <template v-if="ticket.timeLimit">
                            <b-icon icon="timer-outline"/>
                            {{ ticket.timeLimit | seconds2duration }}
                        </template>
                        <template v-else>
                            <b-icon icon="timer-off-outline"/>
                        </template>
                    </div>
                </article>
            </router-link>
        </div>

        <b-pagination
            @change="changePage"
            :total="total"
            v-model="current"
            :range-before="2"
            :range-after="2"
            :per-page="12"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
        </b-pagination>
    </section>
</template>

<script>
import { chunk, map } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import ContextMixin from '../../../mixins/ContextMixin'
import { STATUS_APPROVED } from '../../../store/models/share/model'

export default {
    mixins: [ContextMixin],
    data () {
        return {
            total: 0,
            current: 1,
            perPage: 0,
            ids: [],
        }
    },
    methods: {
        ...mapActions({
            fetchItems: 'e/tickets/fetchItems',
        }),
        changePage (page) {
            this.fetch(page)
        },
        fetch (page) {
            this.fetchItems({CurrentPage: page}).then((res) => {
                this.total = res.data.meta.total
                this.current = res.data.meta.current_page
                this.perPage = res.data.meta.per_page
                this.ids = map(res.data.data, 'id')
            })
        },
        contextChangedHandler() {
            this.fetch(1)
        }
    },
    created () {
        this.fetch(1)
    },
    computed: {
        ...mapGetters({
            tickets: 'e/tickets/ticketsIndex',
            ticketsQuery: 'e/tickets/query',
            isLoaderActive: 'e/pages/isLoaderActive',
        }),
        isLoading () {
            return this.isLoaderActive('tickets.fetchItems')
        },
        chunkedTickets () {
            return chunk(this.ticketsQuery().findIn(this.ids), 3)
        },
    },
}
</script>
